export const getGoogleReviews = async () => {
  const response = await fetch('/.netlify/functions/google-reviews');

  if (!response.ok) {
    const errorBody = await response.text();
    throw new Error(errorBody || 'Failed to load Google reviews');
  }

  const payload = await response.json();
  if (payload?.fallback || payload?.error) {
    throw new Error(payload?.error || 'Google reviews unavailable');
  }

  return Array.isArray(payload?.reviews) ? payload.reviews : [];
};
